<script setup>
defineProps({
  block: {
    type: Object,
    default: () => ({}),
  },
})

const rowContainsTotaleOre = (row) => {
  if (!row) return false
  return Object.values(row).some((value) => value?.includes('totale-ore'))
}

const rowContainsModuli = (row) => {
  if (!row) return false
  return Object.values(row).some((value) => value?.includes('moduli'))
}

const rowContainsLink = (row) => {
  if (!row) return false
  return Object.values(row).some((value) => value?.includes('link'))
}

const getRowClass = (row) => {
  if (rowContainsTotaleOre(row)) return 'totale-row'
  if (rowContainsModuli(row)) return 'moduli-row'
  if (rowContainsLink(row)) return 'link-row underline-animation-reverse'
  return ''
}
</script>

<template>
  <div class="table-block p-bottom-xl-1 row-130-25 max">
    <!-- eslint-disable vue/no-v-html -->
    <div class="container max-content text-xs-1">
      <div>
        <table>
          <thead>
            <tr class="first-row">
              <th v-for="column in block.tabella.columns" :key="column">
                {{ column }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="row in block.tabella.data"
              :key="row?.Discipline"
              :class="getRowClass(row)"
            >
              <td v-for="column in block.tabella.columns" :key="column">
                <div v-html="row ? row[column] : ''" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableBlock',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
